import Conta from "model/administracao/cadastro/Conta";
import LoginValidado from "model/login/LoginValidado";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import UsuarioService from "service/administracao/cadastro/UsuarioService";
import LoginService from "service/login/LoginService";

type Props = {
    visible?: boolean;
    onHide: () => void;
}

const usuarioService = new UsuarioService();
const loginService = new LoginService();
export default function ModalTrocarConta(props: Props) {

    const [contas, setContas] = useState<Conta[]>([]);
    const [contaSelecionada, setContaSelecionada] = useState<Conta | null>(null);

    useEffect(() => {
        usuarioService.contasDoUsuario()
            .then(data => setContas(data))
            .catch(err => console.error(err));
    }, [])

    function trocarConta() {
        if (contaSelecionada) {
            loginService.trocarConta(contaSelecionada.id).then((dadosLogin: LoginValidado) => {
                localStorage.setItem("token", dadosLogin.token);
                if (window.location.href == "/") {
                    window.location.reload();
                } else {
                    window.location.href = "/";
                }

            }).catch(err => console.error(err));
        }
    }

    return <Dialog
        header="Trocar Conta"
        visible={true}
        onHide={() => props.onHide()}
        style={{ width: '500px' }}
        footer={<>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-danger" onClick={() => props.onHide()} />
            <Button label="Trocar" icon="pi pi-arrow-right-arrow-left" disabled={contaSelecionada == null} onClick={() => trocarConta()} />
        </>}
    >
        <Dropdown
            value={contaSelecionada} onChange={(e) => setContaSelecionada(e.target.value)}
            options={contas} optionLabel="nome"
            placeholder="Selecione a conta" style={{ width: '100%' }} />
    </Dialog>
}